export function getFormatedNumber(number: number) {
    if(number){
        return number.toFixed(2);
    }
    return '0.00'
}